import { useEffect } from 'react';
import errorPage from '../assets/img/error-page.svg';
import { useDispatch } from 'react-redux';
import { setPageTitle } from '../store/slices/pageTitleSlice';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth-config';

const Error403 = () => {
    const dispatch = useDispatch();
    const { instance } = useMsal();

    useEffect(() => {
        dispatch(setPageTitle('Error | Spire360'));
    }, []);

    const handleLogout = async () => {
        await instance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin,
        });
    };

    return (
        <main className='main'>
            <div className="main__content-full px-5 pt-4 pb-5">
                <div className="row align-items-center h-100">
                    <div className='col-md-6 text-md-end'>
                        <img src={errorPage} className='img-fluid vh-65'/>
                    </div>
                    <div className='col-md-6'>
                        <h1 className='text-secondary'>Hold on...</h1>
                        <h3 className='text-base'>Access Denied</h3>
                        <div className='text-light mb-4'>Your account is not registered in our system. Please contact your administrator for access.</div>
                        <div className='d-flex gap-3'>
                            <button
                                className='btn btn-outline-secondary'
                                onClick={handleLogout}
                            >
                                Sign out
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Error403;
